export const ATTRIBUTED_EMISSIONS_METRIC_ID = 'tco2eAttributedQuantity';
export const ATTRIBUTED_LOCATION_EMISSIONS_METRIC_ID =
  'tco2eAttributedLocationQuantity';
